import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Voucher } from 'depoto-core/src/entities'
import { CoreService } from '../core.service'

@Injectable({ providedIn: 'root' }) // todo do i need this
export class VoucherService {
  private http = inject(HttpClient)
  core = inject(CoreService)

  public async getVoucher(id, schema = { id: null }): Promise<Voucher | Partial<Voucher>> {
    return new Voucher(await this.core.services.voucher.getById(id, schema))
  }

  async getVouchers(
    // todo
    parameters: any = {
      page: 1,
      sort: 'id',
      direction: 'asc',
    },
    schema: any = { id: null }
  ): Promise<{
    items: Voucher[]
    paginator: { current: null; endPage: null; totalCount: null }
  }> {
    return await this.core.services.voucher.getList(parameters, schema)
  }

  createVoucher(
    voucher: Voucher | Partial<Voucher>,
    schema: Voucher | Partial<Voucher>
  ): Promise<Voucher | Partial<Voucher>> {
    return this.core.services.voucher.create(voucher, schema)
  }

  updateVoucher(
    voucher: Voucher | Partial<Voucher>,
    schema: Voucher | Partial<Voucher>
  ): Promise<Voucher | Partial<Voucher>> {
    return this.core.services.voucher.update(voucher, schema)
  }

  deleteVoucher(voucher: Partial<Voucher>): Promise<Voucher> {
    return this.core.services.voucher.delete(voucher)
  }
}
